// This file added by Bearer Web Developer - Schedule as a Future Order
import { cast, getParentOfType, Instance, types } from "mobx-state-tree";
import getToday from "../../app/getToday";
import getNextSomeDays from "../../app/getNextSomeDays";
import { OrderState } from "../app-state";
export enum TimeSensitiveEnum {
    DueSoon = "Due Soon",
    PastDue = "Past Due",
    DueToday = "Due Today",
    DueTodayPastTime = "Due Today Past Time",
    TimeSensitive = "Time Sensitive",
}
export enum EarliestEnum {
    Now = "Now",
    PickADate = "Pick a Date"
}
// Dynamic allTimes, latestHour and minuteStep start
export type TTimes = "8:00" | "8:30" | "9:00" | "9:30" | "10:00" | "10:30" | "11:00" | "11:30" | "12:00" | "12:30" | "13:00" | "13:30" | "14:00" | "14:30" | "15:00" | "15:30" | "16:00" | '16:30' | '17:00' | '17:30' | '18:00' | '18:30' | '';
let allTimes: TTimes[] = ["8:00", "8:30", "9:00", "9:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", '16:30', '17:00', '17:30', '18:00', '18:30'];
const latestHour = 18;
const minuteStep = 30;
// Dynamic allTimes, latestHour and minuteStep end
export function compareDateRemaining(date: string, latest: string, equal?: boolean) {
    const [year, month, day] = date?.split('-').map(Number);
    const [latestYear, latestMonth, latestDay] = latest?.split('-').map(Number);
    const latestBeforeDate = latestYear < year || (latestYear === year && (latestMonth < month || (latestMonth === month && latestDay < day)));
    const dateEqualLatest = year === latestYear && latestMonth === month && day === latestDay;
    return latestBeforeDate || (equal && dateEqualLatest);
}
export function compareDateEqual(date: string, latest: string) {
    const [year, month, day] = date?.split('-').map(Number);
    const [latestYear, latestMonth, latestDay] = latest?.split('-').map(Number);
    const dateEqualLatest = year === latestYear && latestMonth === month && day === latestDay;
    return dateEqualLatest;
}
export function compareDatePast(date: string, latest: string, equal?: boolean) {
    const [year, month, day] = date?.split('-').map(Number);
    const [latestYear, latestMonth, latestDay] = latest?.split('-').map(Number);
    const dateBeforeLatest = year < latestYear || (year === latestYear && (month < latestMonth || (latestMonth === month && day < latestDay)));
    const dateEqualLatest = year === latestYear && latestMonth === month && day === latestDay;
    return dateBeforeLatest || (equal && dateEqualLatest);
}
export function getValidateDate() {
    const now = new Date();
    const nowTime = `${now.getHours()}:${now.getMinutes()}`;
    // const nowTime = `23:00`; // For testing purpose, assume current time is 23:00
    const [hour, minute] = nowTime.split(":").map(Number);
    if (hour > latestHour || (hour === latestHour && minute >= minuteStep)) return getNextSomeDays(1);
    else return getToday();
}
export function getValidateTimes(date: string | null = getToday(), initTime?: string | null, hourTimeStep: number = 0, getAllTimes?: boolean) {

    if (getAllTimes) return allTimes;
    // hourTimeStep is hour time step between earleast and latest
    if (initTime) {
        return allTimes.filter(time => {
            const [hour, minute] = time.split(":").map(Number);
            const [initHour, initMinute] = initTime?.split(":").map(Number);
            return (hour > (initHour + hourTimeStep) || (hour === (initHour + hourTimeStep) && minute >= initMinute));  // when hourTimeStep has a value
        });
    }
    const firstDate = getValidateDate();
    const now = new Date();
    const nowTime = `${now.getHours()}:${now.getMinutes()}`;
    // const nowTime = `23:00`; // For testing purpose, assume current time is 23:00
    const [hour, minute] = nowTime.split(":").map(Number);
    if (hour > latestHour || (hour === latestHour && minute >= minuteStep) && date === getToday()) return allTimes;
    if (date !== firstDate) return allTimes;
    const firstTime = `${now.getHours()}:${now.getMinutes()}`;
    // const firstTime = `23:00`; // For testing purpose, assume current time is 23:00
    return allTimes.filter(time => {
        const [hour, minute] = time.split(":").map(Number);
        const [hourFirstTime, minuteFirstTime] = firstTime.split(":").map(Number);
        return (hour > (hourFirstTime + hourTimeStep)) || (hour === (hourFirstTime + hourTimeStep) && minute >= minuteFirstTime);
    });
}
function getInitialLatestDate() {
    const validateTimes = getValidateTimes(getToday(), getValidateTimes()[0], 2);
    const initialDate = getValidateDate();
    if (validateTimes.length === 0) return getNextSomeDays(1, initialDate); // next day start with 8:00 oclock
    else return initialDate;
}
function getInitialLatestTimes() {
    const validateTimes = getValidateTimes(getToday(), getValidateTimes()[0], 2);
    if (validateTimes.length === 0) return getValidateTimes(null, null, 2, true); // next day start with 8:00 oclock - get all times
    else return validateTimes;
}
function getInitialEarliestDate() {
    const validateTimes = getValidateTimes();
    const initialDate = getValidateDate();
    if (validateTimes.length === 0) return getNextSomeDays(1, initialDate); // next day start with 8:00 oclock
    else return initialDate;
}
function getInitialEarliestTimes() {
    const validateTimes = getValidateTimes();
    if (validateTimes.length === 0) return getValidateTimes(null, null, 0, true); // next day start with 8:00 oclock - get all times
    else return validateTimes;
}
export const ScheduleOrderstate = types
    .model("ScheduleOrderstate", {
        earliestPickup: types.optional(types.frozen<EarliestEnum>(), EarliestEnum.Now),
        earliestDate: types.optional(types.string, getInitialEarliestDate() || ''),
        earliestTime: types.optional(types.frozen<TTimes>(), getInitialEarliestTimes()[0] || ''),
        latestDate: types.optional(types.string, getInitialLatestDate() || ''),
        latestTime: types.optional(types.frozen<TTimes>(), getInitialLatestTimes()[0] || ''),
        earliestTimeOptions: types.optional(types.array(types.frozen<TTimes>()), getInitialEarliestTimes() || []),
        latestTimeOptions: types.optional(types.array(types.frozen<TTimes>()), getInitialLatestTimes() || []),
        schedule: types.optional(types.boolean, false), // is_time_sensitive_order
        editing: types.optional(types.boolean, false),
        timeSensitive: types.maybeNull(types.frozen<TimeSensitiveEnum>()),
    })
    .actions(self => {
        return {
            updateLatestDateAndTime(earliest: string, latest: string) {
                // Update latest date and time start
                const latestBeforeEarliest = compareDateRemaining(earliest, latest);
                if (earliest === latest || latestBeforeEarliest) {
                    const times = getValidateTimes(earliest, self.earliestTime, 2); // Get valid times for latest time options
                    if (times.length === 0) {
                        const allTimes = getValidateTimes(null, null, 0, true); // get all times
                        const maxDate = getNextSomeDays(7);
                        const nextDate = getNextSomeDays(1, earliest);
                        if (compareDateRemaining(maxDate, nextDate, true)) {
                            self.latestDate = getNextSomeDays(1, earliest);
                            self.latestTime = allTimes[0];
                            self.latestTimeOptions = cast(allTimes);
                        } else {
                            self.latestDate = '';
                            self.latestTime = '';
                            self.latestTimeOptions = cast([]);
                        }
                    } else {
                        if (self.latestDate !== earliest) self.latestDate = earliest;
                        if (!times.includes(self.latestTime)) {
                            self.latestTime = times[0];
                        }
                        self.latestTimeOptions = cast(times);
                    }
                } else {
                    const allTimes = getValidateTimes(null, null, 0, true); // get all times
                    if (!allTimes.includes(self.latestTime)) {
                        self.latestTime = allTimes[0];
                    }
                    self.latestTimeOptions = cast(allTimes);
                }
                // Update latest date and time end
            },
            updateLatestDateAndTimeForPastDue(earliest: string) {
                // Update latest date and time For Past Due start
                const times = getValidateTimes(earliest, self.earliestTime, 2); // Get valid times for latest time options
                if (times.length === 0) {
                    const allTimes = getValidateTimes(null, null, 0, true); // get all times
                    const maxDate = getNextSomeDays(7);
                    const nextDate = getNextSomeDays(1, earliest);
                    if (compareDateRemaining(maxDate, nextDate, true)) {
                        self.latestDate = getNextSomeDays(1, earliest);
                        self.latestTime = allTimes[0];
                        self.latestTimeOptions = cast(allTimes);
                    } else {
                        self.latestDate = '';
                        self.latestTime = '';
                        self.latestTimeOptions = cast([]);
                    }
                } else {
                    if (self.latestDate !== earliest) self.latestDate = earliest;
                    self.latestTime = times[0];
                    self.latestTimeOptions = cast(times);
                }
                // Update latest date and time For Past Due end
            }
        }
    })
    .actions(self => {
        return {
            setSchedule(value: boolean) {
                self.schedule = value;
            },
            setTimeSensitive(value: TimeSensitiveEnum | null) {
                self.timeSensitive = value;
            },
            setEditing(value: boolean) {
                self.editing = value;
            },
            reset() {
                if (self.schedule) self.schedule = false;
                if (self.editing) self.editing = false;
                self.timeSensitive = null;
            },
            setEarliestDate(value: string) {
                self.earliestDate = value;
                const times = getValidateTimes(value);
                if (!times.includes(self.earliestTime)) {
                    self.earliestTime = times[0];
                }
                self.earliestTimeOptions = cast(times);
                self.updateLatestDateAndTime(value, self.latestDate);
            },
            setEarliestTime(value: string) {
                self.earliestTime = value as TTimes;
                self.updateLatestDateAndTime(self.earliestDate, self.latestDate);
            },
            setEarliestPickup(value: EarliestEnum) {
                self.earliestPickup = value;
            },
            toggleEarliestPickup(earliestPickupValue?: EarliestEnum, pastDue?: boolean) {
                const value = earliestPickupValue ? earliestPickupValue : self.earliestPickup === EarliestEnum.Now ? EarliestEnum.PickADate : EarliestEnum.Now;
                if (value === EarliestEnum.Now) {
                    const earliestDate = getValidateDate() || ''
                    self.earliestDate = earliestDate;
                    const times = getValidateTimes();
                    self.earliestTime = times[0];
                    self.earliestTimeOptions = cast(times);
                    if (pastDue) {
                        self.updateLatestDateAndTimeForPastDue(earliestDate);
                    } else {
                        self.updateLatestDateAndTime(earliestDate, self.latestDate);
                    }
                }
                self.earliestPickup = value;
            },
            setLatestDate(value: string) {
                self.latestDate = value;
                self.updateLatestDateAndTime(self.earliestDate, value);
            },
            setLatestTime(value: string) {
                self.latestTime = value as TTimes;
            },
            setScheduleForReservedOrder(value: IScheduleOrderstate) {
                self.schedule = value.schedule; // true
                self.editing = value.editing; // false
                self.earliestDate = value.earliestDate;
                const times = getValidateTimes(value.earliestDate);
                if (!times.includes(self.earliestTime)) {
                    self.earliestTime = times[0];
                }
                self.earliestTimeOptions = cast(times);
                self.latestDate = value.latestDate;
                self.earliestTime = value.earliestTime;
                self.latestTime = value.latestTime;
                self.earliestPickup = EarliestEnum.PickADate;
                self.timeSensitive = value.timeSensitive;
                self.updateLatestDateAndTime(value.earliestDate, value.latestDate);
            },
        }
    }).views(self => ({
        get scheduleOrderSetting() {
            if (self?.timeSensitive &&
                (self?.timeSensitive === TimeSensitiveEnum.PastDue || self?.timeSensitive === TimeSensitiveEnum.DueTodayPastTime)
            ) return false;
            return (!self?.schedule || (self?.schedule && !self?.editing));
        },
        get earliestPickupTime() {
            // earliest_pickup_time
            if (!self.schedule || self.earliestPickup === EarliestEnum.Now) return Date.now();
            else {
                const time = self.earliestTime.split(":").map(i => i.padStart(2, "0")).join(":");
                const timestamp = new Date(`${self.earliestDate}T${time}:00`).getTime();
                return timestamp;
            }
        },
        get latestPickupTime() {
            // latest_pickup_time
            if (!self.schedule) return 9999999999999;
            else {
                const time = self.latestTime.split(":").map(i => i.padStart(2, "0")).join(":");
                const timestamp = new Date(`${self.latestDate}T${time}:00`).getTime();
                return timestamp;
            }
        },
        get isDisabled() {
            const riderInfo = getParentOfType(self, OrderState).transport.riderInfo;
            if (riderInfo) {
                return true;
            }
            return false;
        },
    }))
export interface IScheduleOrderstate extends Instance<typeof ScheduleOrderstate> { };